module.exports = __webpack_public_path__ + "img/icon1.b4dd67d5.svg";